import FullScreenPanel from "app/ui/FullScreenPanel";
import MenuButton from "app/ui/MenuButton";
import { useEffect } from "react";

interface TutorialSkipConfirmProps {
  onBackOut: () => void;
  onConfirm: () => void;
}

// Settings menu UI
export default function TutorialSkipConfirm({
  onBackOut,
  onConfirm,
}: TutorialSkipConfirmProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <FullScreenPanel
      heading="Skip tutorial?"
      headingClassName="px-9 pb-5"
      panelClassName="md:h-auto lg:h-auto shrink"
      childDivClassName="flex-col justify-start items-center text-center gap-2 h-full pb-5"
      hideCloseButton={true}
    >
      <p>
        Are you sure you want to <strong>skip the tutorial?</strong>
      </p>
      <p>
        <i>
          Note: If you skip it now, you can still play the tutorial later using
          the game menu.
        </i>
      </p>
      <div className="grow" />
      <div // BUTTON CONTAINER
        className="flex flex-col justify-center items-center gap-4 mt-4"
      >
        <MenuButton className="max-w-none px-5" onClick={onBackOut}>
          Don't skip
        </MenuButton>
        <MenuButton
          variant="small"
          className="text-lg w-auto"
          onClick={onConfirm}
        >
          Skip
        </MenuButton>
      </div>
    </FullScreenPanel>
  );
}
